<template>
	<div class="DeleteIcon svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1691409144686" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23362" :width="size" :height="size">
			<path
				d="M926.72 102.4h-153.6V51.2c0-28.16-23.04-51.2-51.2-51.2H312.32c-28.16 0-51.2 23.04-51.2 51.2v51.2H107.52c-28.16 0-51.2 23.04-51.2 51.2v35.84c0 8.704 6.656 15.36 15.36 15.36h890.88c8.704 0 15.36-6.656 15.36-15.36v-35.84c0-28.16-23.04-51.2-51.2-51.2zM107.52 870.4c0 84.992 68.608 153.6 153.6 153.6h512c84.992 0 153.6-68.608 153.6-153.6V256H107.52v614.4z m577.536-343.04c0-16.896 13.824-30.72 30.72-30.72s30.72 13.824 30.72 30.72v225.28c0 16.896-13.824 30.72-30.72 30.72s-30.72-13.824-30.72-30.72v-225.28zM486.4 506.88c0-16.896 13.824-30.72 30.72-30.72s30.72 13.824 30.72 30.72v266.24c0 16.896-13.824 30.72-30.72 30.72s-30.72-13.824-30.72-30.72V506.88z m-198.656 20.48c0-16.896 13.824-30.72 30.72-30.72s30.72 13.824 30.72 30.72v225.28c0 16.896-13.824 30.72-30.72 30.72s-30.72-13.824-30.72-30.72v-225.28z"
				fill="#d81e06"
				p-id="23363"
			></path>
		</svg>
	</div>
</template>
<script setup name="DeleteIcon">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 15
		}
	})
</script>
<style scoped lang="less">
	.DeleteIcon,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
